// import React from 'react';
// import AboutPage from './Pages/About Page/AboutPage';
// import './App.css';
// import ServicesPage from './Pages/ServicesPage/ServicesPage';
// import NuringCare from './components/Services/NursingCare/NursingCare';
// import Navigation from './components/Navigations/Navigation';
// import HomePage from './Pages/HomePage/HomePage';
// import { createBrowserRouter, RouterProvider } from "react-router-dom"; 
// import { Link } from "react-router-dom";
// import GalleryPage from './Pages/GalleryPage/GalleryPage';
// import ContactPage from './Pages/ContactPage/ContactPage';
// import BabyCare from './components/Services/BabyCare/BabyCare';
// import ElderlyCare from './components/Services/ElderlyCare/ElderlyCare';
// import HomeHealthCare from './components/Services/HomeHealthCare/HomeHealthCare';
// import MotherCare from './components/Services/MotherCare/MotherCare';
// import PatientCare from './components/Services/PatientCare/PatientCare';
// import Physiptherapy from './components/Services/Physiptherapy/Physiptherapy';

// const App = () => {
//   const router = createBrowserRouter([
//     {
//       path: "/",
//       element: <HomePage />
//     },
//     {
//       path: "/About",
//       element: <AboutPage />
//     },
//     {
//       path: "/Services",
//       element: <ServicesPage /> 
//     },
//     {
//       path: "/Services/nursingcare",
//       element: <NuringCare /> 
//     },
//     {
//       path: "/Services/babycare",
//       element: <BabyCare /> 
//     },   {
//       path: "/Services/ElderlyCare",
//       element: <ElderlyCare /> 
//     },   {
//       path: "/Services/HomeHealthCare",
//       element: <HomeHealthCare /> 
//     },
//     {
//       path: "/Services/MotherCare",
//       element: <MotherCare /> 
//     },
//     {
//       path: "/Services/PatientCare",
//       element: <PatientCare /> 
//     },
//     {
//       path: "/Services/Physiotherapy",
//       element: <Physiptherapy /> 
//     },

//     {
//       path: "/Gallery",
//       element: <GalleryPage />
//     },
//     {
//       path: "/Contact",
//       element: <ContactPage /> 
//     },
//   ]);

//   return (
//     <div className="App">
//         <RouterProvider router={router}>
//           <Navigation/>
       
//           <Link to="/About">About</Link>
//           <Link to="/Services">Services</Link>
//           <Link to="/Contact">Contact</Link>
//         <div><HomePage/></div>
//     </RouterProvider>
//       </div>
//   );
// }

// export default App;



import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import './App.css';

import Navigation from './components/Navigations/Navigation';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop'; // Import the component

// Pages and Components
import HomePage from './Pages/HomePage/HomePage';
import AboutPage from './Pages/About Page/AboutPage';
import ServicesPage from './Pages/ServicesPage/ServicesPage';
import GalleryPage from './Pages/GalleryPage/GalleryPage';
import ContactPage from './Pages/ContactPage/ContactPage';

// Services
import NursingCare from './components/Services/NursingCare/NursingCare';
import BabyCare from './components/Services/BabyCare/BabyCare';
import ElderlyCare from './components/Services/ElderlyCare/ElderlyCare';
import HomeHealthCare from './components/Services/HomeHealthCare/HomeHealthCare';
import MotherCare from './components/Services/MotherCare/MotherCare';
import PatientCare from './components/Services/PatientCare/PatientCare';
import Physiotherapy from './components/Services/Physiptherapy/Physiptherapy';
import Senior from './components/Services/Senior/Senior';
import Attendants from './components/Services/Attendants/Attendants';
import Male from './components/Services/Male/Male';
import Colostomy from './components/Services/Colostomy/Colostomy';
import Critical from './components/Services/Critical/Critical';
import Dementia from './components/Services/Dementia/Dementia';
import Gastrostomy from './components/Services/Gastrostomy/Gastrostomy';
import Ileostomy from './components/Services/Ileostomy/Ileostomy';
import Tracheostomy from './components/Services/Tracheostomy/Tracheostomy';
import HomePatientCare from './components/Services/HomePatientCare/HomePatientCare';

// Not Found Page
const NotFoundPage = () => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>404 - Page Not Found</h1>
    <p>The page you're looking for doesn't exist.</p>
  </div>
);

// Layout Component
const Layout = () => (
  <>
    <Navigation />
    <ScrollToTop /> {/* Ensure scrolls to top when route changes */}
    <main>
      <Outlet />
    </main>
    <Footer />
  </>
);

// Router Configuration
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '/services', element: <ServicesPage /> },
      { path: '/services/nursingcare', element: <NursingCare /> },
      { path: '/services/babycare', element: <BabyCare /> },
      { path: '/services/elderlycare', element: <ElderlyCare /> },
      { path: '/services/homehealthcare', element: <HomeHealthCare /> },
      { path: '/services/mothercare', element: <MotherCare /> },
      { path: '/services/patientcare', element: <PatientCare /> },
      { path: '/services/homepatientcare', element: <HomePatientCare /> },
      { path: '/services/physiotherapy', element: <Physiotherapy /> },
      { path: '/services/male', element: <Male /> },
      { path: '/services/attendants', element: <Attendants /> },
      { path: '/services/colostomy', element: <Colostomy /> },
      { path: '/services/critical', element: <Critical /> },
      { path: '/services/dementia', element: <Dementia /> },
      { path: '/services/gastrostomy', element: <Gastrostomy /> },
      { path: '/services/ileostomy', element: <Ileostomy /> },
      { path: '/services/senior', element: <Senior /> },
      { path: '/services/tracheostomy', element: <Tracheostomy /> },
      { path: '/gallery', element: <GalleryPage /> },
      { path: '/contact', element: <ContactPage /> },
      { path: '*', element: <NotFoundPage /> }, // Catch-all route for 404
    ],
  },
]);

// App Component
const App = () => {
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
